
export enum UserRoles {
    SuperAdmin = 'DF78B0F1-237D-4DDF-823B-D754931FEC1E',
    Administrator = '7A9DE004-AF9A-4106-AF9A-E72413F555B0',
    Artist = 'ebcbee45-442e-4e78-b7be-4fd31bd459b8',
    Gallery = '6672685F-8D46-4BCB-97E0-F4B0C4273DE1',
    GalleryStaff = '2D6960BE-25ED-4CD6-A769-3BCE25D7DC5D'
    // Note: Judge and Curator are GalleryStaff with GalleryStaffPosition = 'Judge' or 'Curator'
}

export enum RefreshTokenRequestSources {
    AppIntializer = 'AppIntializer',
    AdminAppComponent = 'AdminAppComponent',
    ErrorInterceptor = 'ErrorInterceptor'
}

export enum NotificationTypes {
    Success,
    Info,
    Error,
    Alert
}
export const ImageUrls = {
    IMAGE1: 'assets/images/thumb_AFP-logo-v02-noTagline-800.png',
};

export enum ChatBoxEventsEnums {
    ConsignmentDispatch = "A6BE8414-8532-4620-B750-B3376F9DAECF",
    ConsignmentAccepted = "95E9BD4E-E5F7-49E2-BE11-4BD0754EBB3A",
    Proposal = "6F7516A1-C967-4A7C-88F0-BBA43DFFB239",
    AcceptProposal = "1B920E65-8A15-4912-94B0-34F1A294F906",
    RejectProposal = "23063EEE-9B23-4DB1-B749-18D52317B30A",
    ProductSold = "024718BC-7221-4AF7-BF24-D849583024D8",
    ProductReturn = "8FC11F23-3076-402E-8868-D2B46011F1F9"
}

// Gallery Event Type
export enum EventType {
    Exhibition = 1,
    Competition = 2
}

// Gallery Artwork Status Filter (for filtering artworks in listing)
export enum GalleryArtworkStatusFilter {
    All = 0,
    Assigned = 1,           // Artworks assigned but not yet reviewed by judge
    JudgeReviewed = 2,      // Artworks reviewed by judge but no curator decision yet
    CuratorReviewed = 3     // Artworks with both judge review and curator decision
}

// Curator Decision Status (Shortlisted = Accepted)
export enum CuratorDecision {
    Shortlisted = 'Shortlisted',    // This means Accepted
    Rejected = 'Rejected'
}

// Gallery Staff Position
export enum GalleryStaffPosition {
    Judge = 'Judge',
    Curator = 'Curator'
}
